import React, { useState } from "react";

import Login from "./Login";
import {
  BasicMenu,
  getPublicData,
  Search,
  useUserProfile,
} from "@dev-apps/common-ui-components";

export default function Menu() {
  const [searchText, setSearchText] = useState("");
  const profile = useUserProfile();

  function onSearch() {
    if (searchText.trim() !== "") {
      window.location.href = `/search/?q=${encodeURIComponent(searchText)}`;
    }
  }

  return (
    <BasicMenu
      data={getPublicData()}
      menuType="public"
      basePath={process.env.NEXT_PUBLIC_BASE_PATH}
    >
      <div className="flex-grow flex items-center flex-row-reverse">
        <Login userProfile={profile} />
        <div className="flex items-center pr-2 2xl:px-4">
          <Search
            value={searchText}
            setValue={setSearchText}
            onSearch={onSearch}
          />
        </div>
      </div>
    </BasicMenu>
  );
}
